import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { RetrievalResultReportModel } from '../retrieval-result-report-model';
import type { RetrievalResultReportState } from '../../types';
import { AbstractModel } from '@patsnap/tahiti-core';

function createInitialRetrievalResultReportState(): RetrievalResultReportState {
    return {
        title: '',
        userInput: '',
        techEssential: '',
        techFeatures: [],
        techFeaturesWithComparedPats: [],
        noveltyReview: [],
        creativityReview: [],
        threshold: 0,
        creator: '',
        generatedTime: 0,
        searchQty: 0,
        comparativeQty: 0,
        nearestQty: 0,
        secondaryApproachQty: 0,
        elements: [],
        elementsLoading: false,
        familyMergeEnabled: false,
        patentCommonEvidenceData: {},
    };
}

@injectable()
export class RetrievalResultReportModelImpl extends AbstractModel<RetrievalResultReportState> implements RetrievalResultReportModel {
    protected _modelData: RetrievalResultReportState = createInitialRetrievalResultReportState();

    dispose(): void {
        this.update(() => createInitialRetrievalResultReportState());
    }
}
